import { useState } from "react";
import { motion } from "framer-motion";
import { courses } from "@/data/courses";
import { archiveCourses } from "@/data/archive";
import { CourseCard } from "@/components/CourseCard";
import { Seo } from "@/components/Seo";

const filters = [
  { key: "all", label: "Všechny kurzy" },
  { key: "dotovane", label: "S příspěvkem ÚP" },
  { key: "komercni", label: "Komerční" },
];

export default function Courses() {
  const [filter, setFilter] = useState("all");
  const list = courses.filter((c) =>
    filter === "all" ? true : filter === "dotovane" ? c.dotovany : !c.dotovany
  );

  return (
    <div data-testid="courses-page" className="bg-gavito-light">
      <Seo title="Kurzy" description="Praktické kurzy umělé inteligence, digitálních dovedností a kybernetické bezpečnosti. Vybrané kurzy lze hradit s příspěvkem Úřadu práce." path="/kurzy" />
      <section className="pt-40 md:pt-48 pb-12">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="max-w-4xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-gavito-green mb-6">
              Vzdělávací nabídka
            </p>
            <h1 className="font-heading font-black text-5xl md:text-7xl tracking-tighter leading-[0.95] text-gavito-navy">
              Naše <span className="text-gavito-green">kurzy.</span>
            </h1>
            <p className="mt-8 text-lg md:text-xl font-medium text-gavito-navy/70 max-w-2xl leading-relaxed">
              Praktické kurzy digitálních dovedností a umělé inteligence – navržené tak, abyste je ihned
              využili ve své práci i v běžném životě.
            </p>
          </motion.div>

          <div className="flex flex-wrap gap-2 mt-10">
            {filters.map((f) => (
              <button
                key={f.key}
                data-testid={`filter-${f.key}`}
                onClick={() => setFilter(f.key)}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${
                  filter === f.key
                    ? "bg-gavito-navy text-white"
                    : "bg-white border border-gavito-navy/15 text-gavito-navy/70 hover:border-gavito-green"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((c, i) => <CourseCard key={c.slug} course={c} index={i} />)}
          </div>
        </div>
      </section>

      {/* PROBĚHLÉ KURZY */}
      <section className="pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="bg-gavito-navy/[0.03] border border-gavito-navy/10 rounded-[2rem] p-8 md:p-12">
            <div className="flex flex-wrap items-end justify-between gap-4 mb-2">
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold bg-gavito-navy/8 text-gavito-navy/55 mb-4">
                  <span className="w-2 h-2 rounded-full bg-gavito-navy/30" /> Již neaktivní · archiv
                </span>
                <h2 className="font-heading font-extrabold text-3xl md:text-4xl tracking-tight text-gavito-navy/70">Proběhlé kurzy</h2>
              </div>
            </div>
            <p className="text-gavito-navy/50 mt-3 max-w-2xl leading-relaxed">
              Výběr kurzů, které jsme už odučili – část z nich v rámci programu Jsem v kurzu od Úřadu práce.
              Aktuální nabídku najdete výše.
            </p>

            <div className="mt-8 divide-y divide-gavito-navy/10">
              {archiveCourses.map((a, i) => (
                <div key={i} data-testid={`archive-course-${i}`} className="flex flex-wrap items-center gap-3 md:gap-6 py-4 opacity-70">
                  <p className="font-heading font-semibold text-base text-gavito-navy/70 leading-snug flex-1 min-w-[60%]">
                    {a.title}
                  </p>
                  {a.up && (
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gavito-green/10 text-gavito-green/80 font-semibold text-xs whitespace-nowrap shrink-0">
                      Jsem v kurzu · Úřad práce
                    </span>
                  )}
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gavito-navy/5 text-gavito-navy/45 font-semibold text-xs whitespace-nowrap shrink-0">
                    <span className="w-1.5 h-1.5 rounded-full bg-gavito-navy/30" /> Proběhlo
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
